import { render, staticRenderFns } from "./BlockSequenceTable.vue?vue&type=template&id=b64896b4&scoped=true"
import script from "./BlockSequenceTable.vue?vue&type=script&lang=js"
export * from "./BlockSequenceTable.vue?vue&type=script&lang=js"
import style0 from "./BlockSequenceTable.vue?vue&type=style&index=0&id=b64896b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64896b4",
  null
  
)

export default component.exports